import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConstants {
    public brokerageEappTitle = 'Brokerage eApp';
    public proposedInsuredPath = "proposed-insured";
    public demoAgentPhoneNumber = "555-55-5555";
    public monthYearFormat = 'MM/dd/yyyy';
     

    //modal component style options
    public modalTitleBold = 'modal-title-bold';
    public modalTextWrapperCentered = 'modal-txt-wrapper-centered';
    public modalParagraphDefault = 'modal-p-default';
    public modalLiDefault = 'modal-li-default';
    public buttonPrimary= 'btn btn-primary';
    public buttonSecondary= 'btn btn-secondary';

    //for getting info out of responses
    public appIdFromData = 'data.ApplicationId';

    //labels
    //for modals
    eAppPortalLabel= 'JH eApp Portal';
    somethingWentWrong = 'Something went wrong';
    technicalError = 'We\'ve experienced a technical error,  please try your request again. We apologize for the inconvenience.';
    technicalIssueTitle = 'We\'re experiencing technical issues';
    technicalFailureMessage = 'We are experiencing technical issues on this page and cannot ' +
    'send the e-application to the proposed insured at this time. Our recommendation ' +
    'is to visit the JH eApp portal. From that page, you can click on “send to proposed insured”' +
    ' to email the application to your client.';
    inconvenienceMessage = 'We apologize for the inconvenience.';
    keepWorkingBtnLabel = 'Keep working';
    emailAccepted = 'Email Accepted';
}